import { render, staticRenderFns } from "./skill_filters.vue?vue&type=template&id=2224b59c"
import script from "./skill_filters.vue?vue&type=script&lang=ts"
export * from "./skill_filters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports